const postings = [
  {
    title: 'Postings',
    icon: 'ExternalLinkIcon',
    enableFeature: true,
    children: [
      {
        title: 'Account Closure',
        enableFeature: true,
        children: [
          {
            title: 'Account Closure',
            route: 'account-closure',
            hasPermission: 'VIEW_ACCOUNT_CLOSURE_POSTING',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Deposit',
        enableFeature: true,
        children: [
          {
            title: 'Cash Deposit',
            route: 'cash-deposit',
            hasPermission: 'VIEW_CASH_DEPOSIT_POSTING_LIST',
            enableFeature: true,
          },
          {
            title: 'Chq Dep (Outward Chqs)',
            route: 'cheque-deposit-list',
            hasPermission: 'VIEW_OUTWARD_CHEQUE_DEPOSIT_POSTING',
            enableFeature: true,
          },
          {
            title: 'Correspondnt Bank Deposit',
            route: 'correspondent-bank-deposit',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'FD Liquidation & Topup',
        enableFeature: true,
        children: [
          {
            title: 'Fixed Deposit Liquidation',
            route: 'fixed-deposit-liquidation',
            hasPermission: 'VIEW_LIQUIDATE_FIXED_DEPOSIT',
            enableFeature: true,
          },
          {
            title: 'Fixed Deposit Top-up',
            route: 'fixed-deposit-top-up',
            hasPermission: 'VIEW_FIXED_DEPOSIT_TOP_UP',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Backdating Posting',
        route: 'backdating-posting',
        hasPermission: 'VIEW_BACKDATING_POSTING',
        enableFeature: true,
      },
      {
        title: 'Withdrawal',
        enableFeature: true,
        children: [
          {
            title: 'Cash Withdrawal',
            route: 'cash-withdrawal-list',
            hasPermission: 'VIEW_CASH_WITHDRAWAL_POSTING_LIST',
            enableFeature: true,
          },
          {
            title: 'Cheque Withdrawal',
            route: 'cheque-withdrawal-list',
            hasPermission: 'VIEW_CHEQUE_WITHDRAWAL_POSTING',
            enableFeature: true,
          },
          {
            title: 'Correspondnt Bank Withdrawal',
            route: 'correspondent-bank-withdrawal',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Single/Batch',
        enableFeature: true,
        children: [
          {
            title: 'Batch GL (Only)',
            route: 'batch-gl-list',
            hasPermission: 'VIEW_BATCH_JOURNAL_POSTING',
            enableFeature: true,
          },
          {
            title: 'Single GL (Only)',
            route: 'gl-posting-list',
            hasPermission: 'VIEW_SINGLE_JOURNAL_POSTING',
            enableFeature: true,
          },
          {
            title: 'Batch GL and Customer',
            route: 'batch-gl-customer-list',
            hasPermission: 'BATCH_GL_CUSTOMER_POSTING',
            enableFeature: true,
          },
          {
            title: 'Batch Customer Deposit',
            route: 'batch-customer-deposit',
            enableFeature: true,
          },
          {
            title: 'Batch Customer Withdrawal',
            route: 'batch-customer-withdrawal',
            enableFeature: true,
          },
          // {
          //   title: 'Batch GL and Customer',
          //   route: 'batch-gl-customer',
          // },
          {
            title: 'Batch GL Upload',
            route: 'batch-gl-upload',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Reversal',
        hasPermission: 'VIEW_REVERSAL_POSTING',
        enableFeature: true,
        children: [
          {
            title: 'Batch Reversal',
            route: 'batch-reversal',
            enableFeature: true,
          },
          {
            title: 'Single Reversal',
            route: 'single-reversal-list',
            enableFeature: true,
          },
          {
            title: 'Same Day Cancel',
            route: 'cancel-posting-list',
            hasPermission: 'CANCEL_POSTING',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Till and Vault',
        enableFeature: true,
        children: [
          {
            title: 'Vault-In & Out',
            route: 'vault-in-and-out',
            enableFeature: true,
          },
          {
            title: 'Till to Till Transfer',
            route: 'till-to-till-transfer',
            enableFeature: true,
          },
          {
            title: 'Sell Cash to Vault',
            route: 'sell-cash-to-vault',
            hasPermission: 'VIEW_SELL_CASH_POSTING',
            enableFeature: true,
          },
          {
            title: 'Buy Cash from Vault',
            route: 'buy-cash-from-vault',
            hasPermission: 'VIEW_BUY_CASH_POSTING',
            enableFeature: true,
          },
          {
            title: 'Shortage/Overage',
            route: 'shortage-overage',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'Local FT',
        hasPermission: 'VIEW_LOCAL_FUNDS_TRANSFER_POSTING',
        enableFeature: true,
        children: [
          {
            title: 'Intra-bank Transfer',
            route: 'intra-bank-transfer-list',
            enableFeature: true,
          },
          // {
          //   title: 'CASA Standing Order',
          //   route: 'casa-standing-order',
          // },
          // {
          //   title: 'CASA & GL Standing Order',
          //   route: 'casa-and-gl-standing-order',
          // },
        ],
      },
      {
        title: 'Other',
        enableFeature: true,
        children: [
          {
            title: 'Backdate Transaction',
            route: 'backdate-transaction',
            enableFeature: true,
          },
          {
            title: 'Loan Repayment',
            route: 'loan-repayment',
            enableFeature: true,
          },
        ],
      },
      {
        title: 'End Of Year Closure',
        enableFeature: true,
        children: [
          {
            title: 'End Of Year Closure',
            route: 'end-of-year-closure',
            hasPermission: 'END_OF_YEAR_POSTING',
            enableFeature: true,
          },
        ],
      },
    ],
  },
]

export default postings
